import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-one-description-non-final',
		defaultMessage: `
Jira Service Management offers integrations with Slack and Microsoft Teams to help your on-call teams get alert notifications and manage alerts directly from chat channels.\n
[Read more about chat tools for alerting](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Chat-tools-for-alerting)`,
		description: 'Transition home chat tools step task one description',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-two-description-non-final',
		defaultMessage: `
Your chat tools are currently connected with Opsgenie. Connect them with Jira Service Management to let your on-call teams work on alerts from their existing chat channels.`,
		description: 'Transition home chat tools step task two description',
	},
	taskTwoActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-two-action-button-non-final',
		defaultMessage: 'Manage chat tools in Jira',
		description: 'Transition home chat tools step task two action button',
	},
	taskThreeDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-three-description-non-final',
		defaultMessage: `
Select the Opsgenie chat integrations that you want to copy to Jira Service Management. The integration will be copied without any changes, but the status will be **OFF** by default. You can make any changes to the integration's settings and then turn it on.\n
Make sure you're a member of the channel connected to the chat integration, else you won't be able to copy it to Jira Service Management.`,
		description: 'Transition home chat tools step task three description',
	},
	taskThreeActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-three-action-button-non-final',
		defaultMessage: 'Manage chat integrations in Jira',
		description: 'Transition home chat tools step task three action button',
	},
	taskFourDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-four-description-non-final',
		defaultMessage: `
To avoid duplicate notifications from Jira and Opsgenie's chat integrations, you can turn off the integrations in Opsgenie.\n
This will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time.`,
		description: 'Transition home chat tools step task four description',
	},
	taskFourTeamAdminDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-description-non-final',
		defaultMessage: `
To avoid duplicate notifications from Jira and Opsgenie's chat integrations, turn off your teams' integrations in Opsgenie.\n
Find your Opsgenie integrations by navigating to a team and select **Integrations**. Select your chat integration from the list and select the **Turn off** button.\n
This will only turn off your Opsgenie chat integrations, the integrations won't be deleted. You can turn it on at any time.`,
		description: 'Transition home chat tools step task four description',
	},
	taskFourActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-four-action-button-non-final',
		defaultMessage: 'Manage chat integrations in Opsgenie',
		description: 'Transition home chat tools step task four action button',
	},
	taskFourTeamAdminActionButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.chat-tools-step.task-four-team-admin-action-button-non-final',
		defaultMessage: 'Go to teams in Opsgenie',
		description: 'Transition home chat tools step task four action button',
	},
});
